import { semanticThemeTokens } from "@appretio/ui-kit";
import { Outlet, type RouteObject } from "react-router-dom";
import { ForecastPage } from "./pages/forecastPage/ForecastPage";
import { InSeasonReviewPage } from "./pages/inSeasonReviewPage/InSeasonReviewPage";

const ROOT = "in-season" as const;

const PATH = {
  FORECAST: "forecast",
  IN_SEASON_REVIEW: "in-season-review"
} as const;

const LABEL = {
  ROOT: "In-season",
  FORECAST: "Forecast",
  IN_SEASON_REVIEW: "In-season Review"
} as const;

const inSeasonRouteHandles = {
  [PATH.FORECAST]: {
    label: LABEL.FORECAST
  },
  [PATH.IN_SEASON_REVIEW]: {
    label: LABEL.IN_SEASON_REVIEW
  }
} as const;

export const inSeasonRoutes: RouteObject = {
  path: ROOT,
  handle: {
    label: LABEL.ROOT,
    background: semanticThemeTokens.backgroundGradient[2]
  },
  element: <Outlet />,
  children: [
    {
      path: PATH.FORECAST,
      handle: inSeasonRouteHandles[PATH.FORECAST],
      element: <ForecastPage />
    },
    {
      path: PATH.IN_SEASON_REVIEW,
      handle: inSeasonRouteHandles[PATH.IN_SEASON_REVIEW],
      element: <InSeasonReviewPage />
    }
  ]
};
